import React, { useState, useEffect, useRef } from 'react';
import * as xlsx from "xlsx";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { LoadingDots } from '../Components/LoadingDots';
import supplierService from '../Services/supplierService';
import priceListService from '../Services/priceListService';
import customerService from '../Services/customerService';
import inventoryService from '../Services/inventoryService';

const AddInventory = () => {
  const [products, setProducts] = useState([]);
  const [profit, setProfit] = useState(0)
  const [loading, setLoading] = useState(false);
  const [date, setDate] = useState(null)
  const [isVisible, setIsVisible] = useState(false)
  const [profitInvisible, setProfitInvisible] = useState(false)

  const [totalPrice, setTotalPrice] = useState(0);
  const [totalWeight, setTotalWeight] = useState(0);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [totalProducts, setTotalProducts] = useState(0);

  const navigate = useNavigate();

  useEffect(() => {
    if (!date) {
      setIsVisible(false)
    } else {
      setIsVisible(true)
    }
  }, [date, profit])

  const handleButtonClick = () => {
    const fileInput = document.getElementById('file-upload');
    fileInput.click();
  };

  const handleProfitChange = (e) => {
    if (e.target.value < 0) return;
    setProfit(e.target.value)
  }

  const handleFileSelect = (e) => {
    e.preventDefault();
    if (e.target.files.length > 0) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = e.target.result;
        ProceedFileRead(data)
      };
      reader.readAsArrayBuffer(e.target.files[0]);
    }
  };

  const ProceedFileRead = (file) => {
    if (file) {
      const workbook = xlsx.read(file, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const json = xlsx.utils.sheet_to_json(worksheet);
      const mappedData = json.map((item, index) => ({
        id: index + 1,
        v_code: typeof item.v_code === '' ? item.v_code.replace('-', '') : item.v_code,
        brand: item.brand || "",
        title: item.title || "",
        qty: parseInt(item.qty || 0),
        weight: parseFloat(item.weight || 0),
        sale_price: item.sale_price
          ? parseFloat(item.sale_price)
          : parseFloat(item.supplier_price) + (parseFloat(item.supplier_price) * profit / 100),
        p_price: parseFloat(item.p_price || 0),
        created_at: date
      }));
      
      setProducts(mappedData);

    const total = mappedData.reduce((acc, product) => ({
      price: acc.price + parseFloat(product.sale_price || 0),
      weight: acc.weight + parseFloat(product.weight || 0),
      qty: acc.qty + parseInt(product.qty || 0),
      count: acc.count + 1,
    }), { price: 0, weight: 0, qty: 0, count: 0 });

      setTotalPrice(total.price);
      setTotalWeight(total.weight);
      setTotalQuantity(total.qty);
      setTotalProducts(total.count);
    } else {
      toast.error("Please upload a file!");
    }
  };

  const UploadProducts = () => {
    setLoading(true);
    const data = { products }; // `products` already has `created_at` in each row
    inventoryService.create(data).then(response => {
      setLoading(false);
      if (response.responseCode === 200) {
        toast.success("Products Imported successfully!");
        navigate('/inventory', { replace: true });
      }
    });
  };
  

  return (
    <main className="mx-10 my-2 p-6 rounded-3xl border border-gray-200 shadow-lg mb-32 bg-white">
      <div className="flex flex-row justify-between mb-8">
        <p className='font-bold text-3xl text-secondary'>Add Price List</p>
      </div>
      <p className='text-gray-400 text-center mb-3'>
        Upload the CSV file in the specified format to quickly add new products.
      </p>
      <hr />
      <div className='grid grid-cols-5 gap-4 mt-6'>
        <input 
          type="date" 
          name="from" 
          value={date} 
          onChange={(e) => setDate(e.target.value)}
          className="primary-input !bg-gray-50" 
        />
      </div>
  
      <div className='flex flex-row items-center justify-end gap-4 mt-4'> 
        <button onClick={() => handleButtonClick()} className={`button-primary ${isVisible && !loading ? "block" : "hidden"}`}>
          Import Price List
        </button>
      </div>
  
      <div className='flex justify-center mt-10'>
        {products.length !== 0 && (
          <button
            onClick={() => UploadProducts()}
            className="button-primary !bg-teal-600"
          >
            {loading ? <LoadingDots /> : ""}
            Upload {products.length} Products
          </button>
        )}
      </div>
  
      <p className='text-black mt-5 flex w-full justify-center ml-2'>
        <span className={`font-bold mr-2`}>{products.length === 0 ? "No " : products.length}</span> Products Found
      </p>
  
      <input
        type="file"
        id="file-upload"
        onChange={(e) => handleFileSelect(e)}
        style={{ display: 'none' }}
      />
    </main>
  );
  
};

export default AddInventory;
